import React, { useEffect, useState } from 'react'
import Topbar from './Topbar'
import { Link, useNavigate } from 'react-router-dom'
import Sidebar_component from './Sidebar_component'
import $ from 'jquery'
import Worklog_summery from './Worklog_summery'
import Employee_prodectiviti from './Employee_prodectiviti'
import Project_work_distribution from './Project_work_distribution'
import Daily_report_view from './Daily_report_view'

export default function () {
    const [selectedEditOption, setSelectedEditOption] = useState('worklogsummery');
    const [membretype, setMembertype] = useState(false);
    const [sidebarOpen, setSidebarOpen] = useState(false);

    useEffect(() => {
        let memtype = localStorage.getItem('membership_type');
        if (memtype === 'free') {
            setMembertype(true);
        }
        offOnEditOption('worklogsummery')
    }, [])

    function offOnEditOption(id) {
        console.log(selectedEditOption);
        setSelectedEditOption(id);
    }
    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };
    return (
        <div>
            <Topbar toggleSidebar={toggleSidebar} />
            <Sidebar_component sidebarOpen={sidebarOpen} />
            <div className='vl_dsh_bodypart'>
                <div className='vl_alltab'>
                    <h2 className='bigfonttabs'>Work Log</h2>
                    <p className='fullwidth pull_left pb-30'>Track daily work updates, time spent, and task progress.</p>
                </div>
                <div className='fullwidth'>
                    <div className='vl_dsh_one_row flex_row'>
                        <div className='flex_div'>
                            <ul className='setting_list'>
                                <li onClick={() => { offOnEditOption('worklogsummery') }}>Summery</li>
                                <li onClick={() => { offOnEditOption('productivity') }}>Employee Productivity Table</li>
                                <li onClick={() => { offOnEditOption('projectwork') }}>Project Work Distribution</li>
                                <li onClick={() => { offOnEditOption('dailyreport') }}>Daily Reports Section</li>
                            </ul>
                        </div>
                        <div className='vl_dsh_four_fifth_flex'>
                            <div className={`fullwidth nodisplay ${selectedEditOption === 'worklogsummery' ? 'activDisplay' : ''}`} id="worklogsummery">
                                <Worklog_summery />
                            </div>

                            <div className={`fullwidth nodisplay ${selectedEditOption === 'productivity' ? 'activDisplay' : ''}`} id="productivity">
                                <Employee_prodectiviti />
                            </div>
                            <div className={`fullwidth nodisplay ${selectedEditOption === 'projectwork' ? 'activDisplay' : ''}`} id="projectwork">
                                <Project_work_distribution />
                            </div>
                            <div className={`fullwidth nodisplay ${selectedEditOption === 'dailyreport' ? 'activDisplay' : ''}`} id="dailyreport">
                                <Daily_report_view />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {membretype && (
                <div className='vl_dsh_popup activebillpop'>
                    <div className='alertbox'>
                        <div className='alertheader'>
                            <h3><i className='ri-alert-line'></i>Alert</h3>
                        </div>

                        <div className='contentarea'>
                            <p>Please upgrade your membership to access this page</p>
                        </div>
                        <div className='alert_btns'>
                            <button onClick={() => window.history.back()}>Back</button>
                        </div>

                    </div>
                </div>
            )}
        </div>
    )
}
